import { createSlice } from '@reduxjs/toolkit';

export const inmunoterapiaSlice = createSlice({
    name: 'inmunoterapia',
    initialState: {
        // id: {
        //     paciente: '',
        //     tipo: '',
        //     fase: '',
        //     fecha: '',
        //     frasco: '',
        //     concentracion: '',
        //     volumenAlergeno: '',
        //     volumenTotal: '',
        //     sitio: '',
        //     alergenos: [],
        //     aplicaciones: [],
        //     comentarios: ''
        // },
    },
    reducers: {
        initPaciente: (state, { payload }) => {
            if (typeof state[payload.id] === 'undefined') {
                state[payload.id] = {
                    paciente: payload.id,
                    comentarios: ''
                };
            }
        },
        clearPaciente: (state, { payload }) => {
            delete state[payload];
        },
        initTipo: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].tipo === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    tipo: payload.tipo,
                };
            }
        },
        setTipo: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].tipo = payload.tipo;
            }
        },
        clearTipo: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].tipo = '';
            }
        },
        initFase: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].fase === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    fase: payload.fase,
                };
            }
        },
        setFase: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].fase = payload.fase;
            }
        },
        clearFase: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].fase = '';
            }
        },
        initFecha: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].fecha === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    fecha: payload.fecha,
                };
            }
        },
        setFecha: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].fecha = payload.fecha;
            }
        },
        clearFecha: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].fecha = '';
            }
        },
        initFrasco: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].frasco === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    frasco: payload.frasco,
                };
            }
        },
        setFrasco: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].frasco = payload.frasco;
            }
        },
        clearFrasco: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].frasco = '';
            }
        },
        initConcentracion: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].concentracion === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    concentracion: payload.concentracion,
                };
            }
        },
        setConcentracion: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].concentracion = payload.concentracion;
            }
        },
        clearConcentracion: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].concentracion = '';
            }
        },
        initVolumenAlergeno: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].volumenAlergeno === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    volumenAlergeno: payload.volumenAlergeno,
                };
            }
        },
        setVolumenAlergeno: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].volumenAlergeno = payload.volumenAlergeno;
            }
        },
        clearVolumenAlergeno: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].volumenAlergeno = '';
            }
        },
        initVolumenTotal: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].volumenTotal === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    volumenTotal: payload.volumenTotal,
                };
            }
        },
        setVolumenTotal: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].volumenTotal = payload.volumenTotal;
            }
        },
        clearVolumenTotal: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].volumenTotal = '';
            }
        },
        initSitio: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].sitio === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    sitio: payload.sitio,
                };
            }
        },
        setSitio: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].sitio = payload.sitio;
            }
        },
        clearSitio: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].sitio = '';
            }
        },
        initLado: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].lado === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    lado: payload.lado,
                };
            }
        },
        setLado: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].lado = payload.lado;
            }
        },
        clearLado: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].lado = '';
            }
        },
        initAlergenos: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].alergenos === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    alergenos: payload.alergenos
                };
            }
        },
        setAlergenos: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].alergenos = payload.alergenos;
            }
        },
        clearAlergenos: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].alergenos = [];
            }
        },
        initAplicaciones: (state, { payload }) => {
            if (typeof state[payload.id] !== 'undefined' && typeof state[payload.id].aplicaciones === 'undefined') {
                state[payload.id] = {
                    ...state[payload.id],
                    aplicaciones: payload.aplicaciones
                };
            }
        },
        setAplicaciones: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].aplicaciones = payload.aplicaciones;
            }
        },
        clearAplicaciones: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].aplicaciones = [];
            }
        },
        setComentarios: (state, { payload }) => {
            if (typeof state[payload.paciente] !== 'undefined') {
                state[payload.paciente].comentarios = payload.comentarios;
            }
        },
        clearComentarios: (state, { payload }) => {
            if (typeof state[payload] !== 'undefined') {
                state[payload].comentarios = '';
            }
        },
    }
});


// Action creators are generated for each case reducer function
export const {
    initPaciente,
    clearPaciente,
    initTipo,
    setTipo,
    clearTipo,
    initFase,
    setFase,
    clearFase,
    initFecha,
    setFecha,
    clearFecha,
    initFrasco,
    setFrasco,
    clearFrasco,
    initConcentracion,
    setConcentracion,
    clearConcentracion,
    initVolumenAlergeno,
    setVolumenAlergeno,
    clearVolumenAlergeno,
    initVolumenTotal,
    setVolumenTotal,
    clearVolumenTotal,
    initSitio,
    setSitio,
    clearSitio,
    initLado,
    setLado,
    clearLado,
    initAlergenos,
    setAlergenos,
    clearAlergenos,
    initAplicaciones,
    setAplicaciones,
    clearAplicaciones,
    setComentarios,
    clearComentarios
} = inmunoterapiaSlice.actions;